import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiLogOut, FiActivity } from 'react-icons/fi';
import Button from '../common/Button';
import MobileMenu from '../mobile/MobileMenu';

const Header = () => {
  const { user, logout } = useAuth();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('ko-KR', { hour12: false });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <header className="h-14 sm:h-16 bg-gray-800 border-b border-gray-700 px-4 sm:px-6 flex items-center justify-between fixed top-0 left-0 right-0 z-40">
      <div className="flex items-center space-x-2 sm:space-x-4">
        <MobileMenu />
        <h1 className="text-lg sm:text-xl font-bold text-blue-500">
          <span className="hidden sm:inline">KOSPI200 Auto Trader</span>
          <span className="sm:hidden">KOSPI200</span>
        </h1>
      </div>

      <div className="flex items-center space-x-2 sm:space-x-6">
        {/* 날짜/시간 - 데스크톱만 표시 */}
        <div className="hidden md:block text-sm">
          <div className="text-gray-400">{formatDate(currentTime)}</div>
          <div className="text-white font-mono">{formatTime(currentTime)}</div>
        </div>

        {/* API 상태 - 데스크톱만 표시 */}
        <div className="hidden md:flex items-center space-x-2">
          <FiActivity className="text-green-500" />
          <span className="text-sm text-gray-400">API 연결: <span className="text-green-500">정상</span></span>
        </div>

        {/* 사용자 정보 및 로그아웃 */}
        <div className="flex items-center space-x-2 sm:space-x-3 sm:pl-6 sm:border-l sm:border-gray-700">
          <span className="hidden sm:block text-sm text-gray-400">{user?.username}</span>
          <Button variant="ghost" size="sm" onClick={logout} className="flex items-center space-x-1 sm:space-x-2">
            <FiLogOut />
            <span className="hidden sm:inline">로그아웃</span>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
